import styled from "styled-components"

import Typography from "~/components/atoms/Typography"
import TextCut from "~/components/molecules/TextCut"
import { Color, SpacingSize } from "~/consts/style-mixins"

interface Props {
  heading?: string
  description: string
}

const DetailDescription = ({ heading, description }: Props) => {
  return (
    <>
      <StyledTypography type="SubHeading">{heading}</StyledTypography>
      <TextCut size="Medium" cutPoint={240}>
        {description}
      </TextCut>
    </>
  )
}

const StyledTypography = styled(Typography)`
  margin-bottom: ${SpacingSize.XS}px;
  color: ${Color.Primary};
`

export default DetailDescription
